export default "__VITE_ASSET__CNVfPL0S__"